import { FC } from 'react';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import { formatGpsCapturedAt } from '@/utils/locationVerificationStart';
import styles from './LocationCaptureMetaBar.module.scss';

type LocationCaptureMetaBarProps = {
  capturedAt: string;
  accuracyMetres: number | null;
};

export const LocationCaptureMetaBar: FC<LocationCaptureMetaBarProps> = ({
  capturedAt,
  accuracyMetres,
}) => {
  const hasAccuracy = typeof accuracyMetres === 'number' && Number.isFinite(accuracyMetres);
  return (
    <div className={styles.metaBar}>
      <span className={styles.metaItem}>
        <AccessTimeOutlinedIcon className={styles.metaIcon} aria-hidden="true" />
        {formatGpsCapturedAt(capturedAt)}
      </span>
      {hasAccuracy && (
        <span className={styles.metaItem}>
          <LocationOnOutlinedIcon className={styles.metaIcon} aria-hidden="true" />±
          {Math.round(accuracyMetres)} m
        </span>
      )}
    </div>
  );
};
